// extracted by mini-css-extract-plugin
export default {"wrapper":"OptionWidget_wrapper__kBhht"};